import React, {MouseEvent, useEffect} from "react"

import classNames from "classnames";
import Button from "./Button";
import Icon from "./Icon";
import styles from '../css/Modal.module.css'
import iconStyles from '../css/Icon.module.css'

export interface Props {
    id: string,
    show?: boolean,
    bottom?: boolean,
    hideCross?: boolean,
    backdropTransparent?: boolean,
    center?: boolean,
    round?: boolean,
    darkBackdrop?: boolean,
    contentClassName?: string,
    disabledBackdropDismiss?: boolean,
    onDismiss?: (event: MouseEvent) => void,
    children?: React.ReactNode,
}

const stopPropagation = (e: MouseEvent) => {
    e.stopPropagation();
};

export default (props: Props) => {

    // Props

    const {
        round,
        hideCross,
        children,
        contentClassName,
        backdropTransparent,
        id,
        show,
        disabledBackdropDismiss,
        darkBackdrop,
        onDismiss,
        bottom,
        center,
    } = props;

    // Effects

    useEffect(() => {
        return () => {
            document.body.classList.remove.bind(null, styles.bodyModalOpen); // ensure body class is removed
        }
    }, []);

    useEffect(() => {
        if (show) {
            document.body.classList.add(styles.bodyModalOpen);
        } else {
            document.body.classList.remove(styles.bodyModalOpen);
        }
    }, [show]);

    return (
        <div
            id={id}
            onClick={disabledBackdropDismiss || darkBackdrop ? undefined : onDismiss}
            className={classNames(styles.modal, {
                [styles.modalShow]: show,
                [styles.modalBottom]: bottom,
                [styles.modalCenter]: center,
                [styles.modalDark]: disabledBackdropDismiss,
                [styles.darkBackdrop]: darkBackdrop,
                [styles.modalTransparent]: backdropTransparent,
            })}>

            {
                (darkBackdrop || disabledBackdropDismiss) && !hideCross &&
                <div className={styles.modalDismissCross}>
                  <Button onClick={onDismiss} alert={disabledBackdropDismiss} xs>
                    <Icon xs name={iconStyles.iconCross}/>
                  </Button>
                </div>
            }

            <div
                onClick={stopPropagation}
                className={classNames(styles.modalContent, {
                    [styles.modalContentRound]: round,
                    [styles.modalContentBottom]: bottom,
                }, contentClassName)}>
                {children}
            </div>

        </div>
    );
}
